// mixpanel-browser is ~1.1 MB. Load it lazily via dynamic import() so it never
// ships in the initial bundle — it is only fetched once analytics consent fires
// initMixpanel() (see the gn:analyticsConsent listener in main.jsx).
let mixpanelInstance = null;

const isMobileDevice = () => {
  return (
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    window.matchMedia("(max-width: 768px)").matches
  );
};

export const initMixpanel = async () => {
  const { default: mixpanel } = await import("mixpanel-browser");

  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    track_pageview: true,
    persistence: "localStorage"
  });

  mixpanel.register({
    device_type: isMobileDevice() ? "mobile" : "desktop"
  });

  mixpanelInstance = mixpanel;
};

export const logUserToMixpanel = (userData) => {
  if (import.meta.env.VITE_ENVIRONMENT !== 'local') {
    // No-op until consent has initialised Mixpanel (mixpanelInstance stays null).
    if (mixpanelInstance && userData && mixpanelInstance.config) {
      mixpanelInstance.identify(userData.id);
      mixpanelInstance.people.set({
        $email: userData.email,
        $first_name: userData.first_name,
        $last_name: userData.last_name,
        user_id: userData.id,
      });
    }
  }
};
